function EmployeeRehire() {
    return (
        <div>
            <h1>
                EmployeeRehireFlow
            </h1>
        </div>
    )
}

export default EmployeeRehire;